import { ContainerComponent, wrap } from 'AppReact';
import {
  NoteInputWrapper, FullWidthFlexCenterWrapper, FlexGrowCenterWrapper,
  FlexCenterWrapper, Mr2, FullWidthFlexCenterBetweenWrapper,
  FullWidthFlexBoxWrapper, BorderBottomWrapper, Mt2, Mb4,
  SendIconWrapper, Mb3
} from 'wrappers';
import Controller from './controller';
import internalState from './internalState';
import { InputRemovableImage, ResidentNotifiedText } from 'molecules';
import { MultipleImageVideoUploadButton, MentionsInput, ClickableIcon, MultipleFileUploadButton } from 'atoms';
import { ImageSvg, SendSvg } from 'components/icons';
import PrivacyDropdown from '../privacyDropdown';

export const definition = {
  name: 'NoteInput',
  initialProps: ({ personsToMention, hasPrivacy, localUrls, uuids, inputVal, acceptDocuments, content_types, placeholder, displayBottom, isEditing, redBorder }) => ({
    personsToMention,
    displayBottom,
    hasPrivacy,
    localUrls: localUrls ?? [],
    content_types: content_types ?? [],
    uuids: uuids ?? [],
    inputVal: inputVal ?? '',
    acceptDocuments,
    placeholder,
    isEditing,
    redBorder,
  }),
  props: internalState,
  controller: Controller,
  elements: [
    {
      component: wrap(ResidentNotifiedText, Mb3),
      name: 'ResidentNotifiedText',
      renderIf: ({ mentioned, personsToMention }) => mentioned.includes(personsToMention.find(p => p.name.includes('(Resident)'))?.id),
      bindings: ({ }) => ({})
    },
    {
      wrapper: NoteInputWrapper,
      displayState: ({ redBorder }) => ({ redBorder }),
      name: 'Wrapper',
      elements: [
        {
          wrapper: wrap(wrap(FullWidthFlexBoxWrapper, BorderBottomWrapper), Mt2),
          renderIf: ({ localUrls }) => localUrls && localUrls.length > 0,
          name: 'ImagesWrapper',
          elements: [
            {
              component: wrap(wrap(InputRemovableImage, Mr2), Mb4),
              name: 'Image',
              isListOf: 'localUrls',
              bindings: ({ localUrl, localUrls, uuids, localUrlIndex, content_types }) => {
                let popup = { text: !localUrl.includes("image") && !localUrl.includes("video") ? 'Click to remove document' : `Click to remove ${localUrl.includes('video') ? 'video' : 'image'}`, position: 'top' };
                let content_type = !localUrl.includes('video') && !localUrl.includes('image') ? 'document' : localUrl.includes('video') ? 'video' : 'image'

                if (content_types && content_types.length > 0 && !!content_types[localUrlIndex]) {
                  popup.text = !content_types[localUrlIndex].includes("image") && !content_types[localUrlIndex].includes("video") ? 'Click to remove document' : `Click to remove ${content_types[localUrlIndex].includes('video') ? 'video' : 'image'}`;
                  content_type = content_types[localUrlIndex];
                }

                return {
                  localUrls, uuids, content_types,
                  url: localUrl,
                  popup,
                  width: '50px', height: '50px',
                  content_type,
                  localUrlIndex
                }
              }
            },
            {
              componentSelect: ({ acceptDocuments }) => acceptDocuments ? wrap(wrap(wrap(MultipleFileUploadButton, FlexCenterWrapper), Mr2), Mb4) : wrap(wrap(wrap(MultipleImageVideoUploadButton, FlexCenterWrapper), Mr2), Mb4),
              bindings: ({ localUrls, uuids, acceptDocuments }) => ({ localUrls, uuids, acceptDocuments }),
              name: 'UploadButton',
              displayValue: ({ }) => ImageSvg({ width: 50, height: 50, bold: true, color: window?.settings?.secondary_color ?? '#04333B' })
            },
          ]
        },
        {
          wrapper: FullWidthFlexCenterBetweenWrapper,
          name: 'Wrapper',
          elements: [
            {
              wrapper: wrap(FullWidthFlexCenterWrapper, FlexGrowCenterWrapper),
              name: 'Input',
              elements: [
                {
                  componentSelect: ({ acceptDocuments }) => acceptDocuments ? wrap(wrap(MultipleFileUploadButton, FlexCenterWrapper), Mr2) : wrap(wrap(MultipleImageVideoUploadButton, FlexCenterWrapper), Mr2),
                  renderIf: ({ localUrls }) => (localUrls && localUrls.length === 0),
                  bindings: ({ localUrls, uuids, acceptDocuments }) => ({ localUrls, uuids, acceptDocuments }),
                  name: 'UploadButton',
                  displayValue: ({ }) => ImageSvg({ width: 24, height: 24, bold: true, color: window?.settings?.secondary_color ?? '#04333B' })
                },
                {
                  component: wrap(MentionsInput, FlexGrowCenterWrapper),
                  name: 'MentionsInput',
                  displayValue: ({ inputVal, personsToMention, mentioned, uuids, privacy, placeholder, displayBottom, isEditing }) => {
                    const _onChange = ({ handle }, o) => {
                      if (o.action === 'submit') {
                        handle({ action: 'submit', value: inputVal, mentioned, personsToMention, uuids, privacy })
                      }
                      if (o.action === 'change') {
                        handle({ action: o.action, value: o.value, mentioned: o.mentioned, personsToMention })
                      }
                    }
                    return {
                      personsToMention: personsToMention,
                      displayBottom,
                      _onChange,
                      onChangeField: 'onChange',
                      inputVal,
                      isEditing,
                      placeholder: placeholder ?? 'Type here or use @ to mention someone'
                    }
                  }
                }
              ]
            },
            {
              wrapper: FlexCenterWrapper,
              name: 'RightSide',
              elements: [
                {
                  component: wrap(PrivacyDropdown, Mr2),
                  name: 'PrivacyDropdown',
                  renderIf: ({ hasPrivacy }) => hasPrivacy,
                  bindings: ({ privacy }) => ({ privacy }),
                },
                {
                  component: wrap(ClickableIcon, SendIconWrapper),
                  name: 'SendIcon',
                  displayValue: ({ inputVal, uuids, isEditing }) => SendSvg({ color: isEditing || inputVal || uuids.length > 0 ? window?.settings?.primary_color ?? '#1DBD6B' : window?.settings?.secondary_color ?? '#04333B' }),
                  bindings: ({ inputVal, uuids, mentioned, personsToMention, privacy, isEditing }) => ({ isEditing, value: inputVal, mentioned, personsToMention, uuids, privacy })
                }
              ]
            },
          ]
        }
      ]
    }
  ]
}

export default ContainerComponent(definition);